(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["big-pack-navigation"]) return;
  try {
    
(()=>{const groups=document.querySelectorAll('.bp-nav-group');function close(group,focus){const b=group.querySelector('button');b.setAttribute('aria-expanded','false');group.querySelector('.bp-submenu').hidden=true;if(focus)b.focus();}groups.forEach(group=>{const b=group.querySelector('button'),panel=group.querySelector('.bp-submenu');b.addEventListener('click',()=>{const open=b.getAttribute('aria-expanded')==='true';groups.forEach(g=>close(g,false));b.setAttribute('aria-expanded',String(!open));panel.hidden=open;});group.addEventListener('focusout',e=>{if(!group.contains(e.relatedTarget))close(group,false);});group.addEventListener('keydown',e=>{if(e.key==='Escape'){close(group,true);e.preventDefault();}});});document.addEventListener('click',e=>{groups.forEach(g=>{if(!g.contains(e.target))close(g,false);});document.querySelectorAll('.bp-mobile-menu[open]').forEach(m=>{if(!m.contains(e.target)||e.target.closest('a'))m.open=false;});});document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.bp-mobile-menu[open]').forEach(m=>{m.open=false;m.querySelector('summary').focus();});});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["big-pack-page"]) return;
  try {
    
(()=>{function init(section){const quiz=section.querySelector('[data-bp-quiz]'),slot=section.querySelector('[data-bp-quiz-slot]');if(!quiz||!slot||quiz.dataset.ready)return;quiz.dataset.ready='true';slot.replaceWith(quiz);quiz.hidden=false;const config=JSON.parse(section.querySelector('[data-quiz-config]').textContent),questions=config.questions.map(q=>JSON.parse(q));let index=0,score=0,answered=false;const el=s=>quiz.querySelector(s),feedback=el('[data-feedback]'),next=el('[data-next]'),restart=el('[data-restart]');function render(){answered=false;const q=questions[index];el('[data-progress]').textContent=(index+1)+' / '+questions.length;el('progress').value=index;el('[data-title]').textContent=q.title;el('legend').textContent=q.question;feedback.textContent='';next.hidden=true;restart.hidden=true;el('fieldset').hidden=false;el('[data-options]').replaceChildren(...q.answers.map((answer,i)=>{const b=document.createElement('button');b.type='button';b.textContent=answer;b.setAttribute('aria-pressed','false');b.addEventListener('click',()=>{if(answered)return;answered=true;if(i===q.correct)score++;b.setAttribute('aria-pressed','true');el('[data-options]').querySelectorAll('button').forEach(x=>x.disabled=true);feedback.textContent=(i===q.correct?config.correct:config.learn)+' '+q.explanation;next.hidden=false;el('progress').value=index+1;next.focus({preventScroll:true})});return b}));}next.addEventListener('click',()=>{index++;if(index<questions.length){render();el('legend').focus({preventScroll:true})}else{el('fieldset').hidden=true;el('[data-title]').textContent=config.complete;el('[data-progress]').textContent=score+' / '+questions.length;feedback.textContent=config.finish;next.hidden=true;restart.hidden=false;restart.focus({preventScroll:true})}});restart.addEventListener('click',()=>{index=0;score=0;render();el('legend').focus({preventScroll:true})});render();}document.querySelectorAll('[data-bp-page]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bp-page]').forEach(init));})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(()=>{
  if(customElements.get('bp-catalog-more'))return;
  class CatalogMore extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.container=this.closest('#ProductGridContainer');this.grid=this.container?.querySelector('#product-grid');
      if(!this.grid||!this.grid.matches('ul'))return;
      this.button=this.querySelector('[data-browse-load]');this.more=this.querySelector('[data-browse-continue]');this.count=this.querySelector('[data-browse-count]');this.status=this.querySelector('[data-browse-status]');
      this.label=this.button.textContent;this.next=this.dataset.next;this.pages=[];this.loading=false;this.key='big-pack-browse:'+location.pathname+location.search;
      this.button.addEventListener('click',()=>this.load(false));
      this.remember=()=>{
        if(!this.pages.length)return;
        try{const key='big-pack-browse:'+location.pathname+location.search;sessionStorage.setItem(key,JSON.stringify({url:location.href,pages:this.pages,y:scrollY,time:Date.now()}));}catch{}
      };
      this.onProductClick=e=>{if(e.target.closest('a[href*="/products/"]'))this.remember();};
      this.grid.addEventListener('click',this.onProductClick);addEventListener('pagehide',this.remember);
      this.hidden=false;this.update();
      const navigation=performance.getEntriesByType('navigation')[0];
      if(navigation?.type==='back_forward')this.restore();
    }
    disconnectedCallback(){this.abort?.abort();removeEventListener('pagehide',this.remember);this.grid?.removeEventListener('click',this.onProductClick);}
    update(){
      const loaded=this.grid.children.length;
      this.count.textContent=this.dataset.count.replace('__COUNT__',String(loaded)).replace('__TOTAL__',this.dataset.total);
      const capped=this.pages.length>=2;
      this.button.hidden=!this.next||capped;this.more.hidden=!this.next||!capped;
      if(this.next)this.more.href=this.next;
    }
    async restore(){
      let saved;try{saved=JSON.parse(sessionStorage.getItem(this.key));sessionStorage.removeItem(this.key);}catch{return;}
      if(!saved||saved.url!==location.href||!Array.isArray(saved.pages)||Date.now()-saved.time>1800000)return;
      this.restoring=true;
      for(const expected of saved.pages.slice(0,2)){
        if(!this.isConnected||!this.next||new URL(this.next,location.href).href!==expected)break;
        const ok=await this.load(true);if(!ok)break;
      }
      this.restoring=false;
      if(this.isConnected&&this.pages.length)requestAnimationFrame(()=>scrollTo({top:Math.max(0,Number(saved.y)||0),behavior:'instant'}));
    }
    async load(restoring){
      if(this.loading||!this.next||this.pages.length>=2)return false;
      let url;try{url=new URL(this.next,location.href);}catch{return false;}
      if(url.origin!==location.origin||url.pathname!==location.pathname)return false;
      const currentURL=location.href,firstCount=this.grid.children.length;this.loading=true;
      this.button.disabled=true;this.button.textContent=this.dataset.loading;this.status.textContent=this.dataset.loading;this.grid.setAttribute('aria-busy','true');
      this.abort=new AbortController();const timeout=setTimeout(()=>this.abort.abort(),12000);
      try{
        const response=await fetch(url.href,{credentials:'same-origin',signal:this.abort.signal});
        if(!response.ok)throw new Error('Page unavailable');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        const nextGrid=html.querySelector('#ProductGridContainer #product-grid'),nextControl=html.querySelector('bp-catalog-more');
        if(!nextGrid||!nextControl||!nextGrid.matches('ul'))throw new Error('Missing products');
        if(!this.isConnected||location.href!==currentURL)return false;
        const known=new Set([...this.grid.querySelectorAll('.full-unstyled-link')].map(a=>a.getAttribute('href')));
        const items=[...nextGrid.children].filter(item=>{const href=item.querySelector('.full-unstyled-link')?.getAttribute('href');return href&&!known.has(href);});
        if(!items.length)throw new Error('No new products');
        const fragment=document.createDocumentFragment();items.forEach(item=>fragment.append(document.importNode(item,true)));this.grid.append(fragment);
        this.pages.push(url.href);this.next=nextControl.dataset.next;this.dataset.total=nextControl.dataset.total;this.update();this.status.textContent=this.count.textContent;
        this.button.textContent=this.label;
        if(!restoring){
          const first=this.grid.children[firstCount],link=first?.querySelector('.full-unstyled-link');
          if(link){link.focus({preventScroll:true});first.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
        }
        return true;
      }catch{
        if(this.isConnected){this.button.textContent=this.dataset.retry;this.status.textContent=this.dataset.error;}
        return false;
      }finally{
        clearTimeout(timeout);this.loading=false;
        if(this.isConnected){this.button.disabled=false;this.grid.setAttribute('aria-busy','false');}
      }
    }
  }
  customElements.define('bp-catalog-more',CatalogMore);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-vault"] && !Shopify.designMode) return;
  try {
    

(()=>{
  const initialize=root=>{
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    const config=JSON.parse(root.querySelector('[data-vault-config]').textContent);
    const stage=root.querySelector('.pv-stage'),pack=stage.querySelector('.pv-pack'),target=stage.querySelector('.pv-rip-target'),reveal=stage.querySelector('.pv-reveal'),replay=stage.querySelector('.pv-again'),status=root.querySelector('.pv-status');
    let opened=false,lastPokemon=-1,nextPokemon;
    const shell=document.createElement('div');shell.className='pv-pack-shell';pack.before(shell);shell.append(pack);shell.append(pack.querySelector('.pv-tear'));stage.append(target);['pv-foil-light','pv-seam'].forEach(name=>{const foil=document.createElement('span');foil.className=name;foil.setAttribute('aria-hidden','true');pack.append(foil);});
    const pool=config.pokemon;
    function prepare(){const choices=pool.filter(p=>p.id!==lastPokemon);nextPokemon=choices[Math.floor(Math.random()*choices.length)];const preload=new Image();preload.src=nextPokemon.url;}
    function populate(){const p=nextPokemon;lastPokemon=p.id;const set=(key,value)=>reveal.querySelector('[data-dex-'+key+']').textContent=value;set('number','#'+String(p.id).padStart(4,'0'));set('name',p.name);set('class',p.category);set('height',p.height);set('weight',p.weight);set('abilities',p.abilities);set('fact',p.fact);const img=new Image(160,160);img.src=p.url;img.alt=p.name;img.decoding='async';reveal.querySelector('[data-dex-art]').replaceChildren(img);reveal.querySelector('[data-dex-types]').replaceChildren(...p.types.map(t=>{const badge=document.createElement('span');badge.textContent=t;return badge}));return p;}
    prepare();
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const motionToggle=root.querySelector('[data-motion-toggle]');
    let motionPaused=reduced.matches;
    const syncMotion=()=>{root.dataset.motionPaused=String(motionPaused);motionToggle.setAttribute('aria-pressed',String(motionPaused));motionToggle.textContent=motionPaused?config.motion.play:config.motion.pause;root.dispatchEvent(new CustomEvent('bigpack:motion'));};
    motionToggle.hidden=false;motionToggle.addEventListener('click',()=>{motionPaused=!motionPaused;syncMotion();});syncMotion();
    const onAmbientMotionChange=()=>{motionPaused=reduced.matches;syncMotion();};reduced.addEventListener('change',onAmbientMotionChange);

    let packyIndex=Math.floor(Math.random()*3);
    const showPacky=()=>{stage.dataset.packy=String(packyIndex);};
    const nextPacky=()=>{packyIndex=(packyIndex+1)%3;showPacky();};
    showPacky();
    const stageObserver=new IntersectionObserver(entries=>{stage.dataset.vaultVisible=String(entries[0].isIntersecting);},{threshold:.1});stageObserver.observe(stage);
    const packyTimer=setInterval(()=>{if(!root.isConnected){clearInterval(packyTimer);return;}if(!reduced.matches&&!motionPaused&&!opened&&phase==='sealed'&&stage.dataset.vaultVisible==='true'&&!document.hidden)nextPacky();},6000);


    let phase='sealed',pointer=null,tear=0,direction=1,motionFrame=0,motionToken=0,suppressClick=false,finishRip=null,suppressClickUntil=0,openProgress=0;
    const clamp=value=>Math.max(0,Math.min(1,value));
    const ease=value=>1-Math.pow(1-value,3);
    const setPhase=value=>{phase=value;stage.dataset.ripState=value;root.dispatchEvent(new CustomEvent('bigpack:rip-state',{detail:{state:value}}));};
    const stopMotion=()=>{motionToken++;if(motionFrame)cancelAnimationFrame(motionFrame);motionFrame=0;};
    const cap=shell.querySelector('.pv-tear');
    const paintFoil=()=>{cap.style.transform='translate('+(direction*(tear*52+openProgress*145))+'px,'+(-tear*36-openProgress*148)+'px) rotate('+(direction*(tear*26+openProgress*34))+'deg)';};
    const paintTear=value=>{tear=clamp(value);stage.style.setProperty('--pv-tear',tear);paintFoil();};
    const paintOpen=(opening,card)=>{
      openProgress=opening;pack.style.transform='translateY('+(opening*245)+'px) rotate('+(direction*opening*13)+'deg)';pack.style.opacity=String(1-clamp((opening-.42)/.58));cap.style.opacity=String(1-clamp((opening-.25)/.7));reveal.style.transform='translate(-50%,'+((1-card)*36)+'px) scale('+(.52+card*.48)+')';reveal.style.opacity=String(clamp(card*8));paintFoil();
      stage.style.setProperty('--pv-open',opening);
      stage.style.setProperty('--pv-card',card);
      stage.style.setProperty('--pv-card-opacity',clamp(card*8));
      stage.style.setProperty('--pv-wrapper-opacity',1-clamp((opening-.42)/.58));
      stage.style.setProperty('--pv-cap-opacity',1-clamp((opening-.25)/.7));
    };
    const setDirection=value=>{direction=value;stage.style.setProperty('--pv-direction',value);stage.style.setProperty('--pv-hinge',value===1?'100% 100%':'0% 100%');stage.style.setProperty('--pv-seam-origin',value===1?'left':'right');};
    function animate(duration,draw,done){
      stopMotion();const token=motionToken,start=performance.now();
      const tick=now=>{if(token!==motionToken||!root.isConnected)return;const progress=clamp((now-start)/duration);draw(progress);if(progress<1)motionFrame=requestAnimationFrame(tick);else{motionFrame=0;done();}};
      motionFrame=requestAnimationFrame(tick);
    }
    function releasePointer(){const active=pointer;pointer=null;if(active&&active.kind==='pointer'){try{if(target.hasPointerCapture&&target.hasPointerCapture(active.id))target.releasePointerCapture(active.id);}catch{}}}
    function snapBack(){
      releasePointer();const from=tear;setPhase('resealing');
      const finish=()=>{paintTear(0);setPhase('sealed');};
      if(reduced.matches||from===0){stopMotion();finish();return;}
      animate(240,value=>paintTear(from*(1-ease(value))),finish);
    }
    const typeSheen={Grass:'#9cdb7e50',Fire:'#ffb17450',Water:'#7ccfed50',Electric:'#f8db7250',Psychic:'#eab0df50',Dragon:'#a9b2f150',Ice:'#adedef50',Steel:'#b9d4de50',Rock:'#dcc49650',Ground:'#dfbc9250',Ghost:'#bdafe050',Dark:'#b4bdcf50',Fairy:'#f1bbdb50',Fighting:'#e6a78c50',Poison:'#cfabe350',Bug:'#b7d88b50',Flying:'#b5d9ed50',Normal:'#d3d5c550'};
    function rip(){
      if(opened||phase==='opening'||phase==='revealing'||phase==='revealed')return;
      releasePointer();stopMotion();const pokemon=populate(),from=tear;opened=true;setPhase('opening');
      stage.style.setProperty('--pv-sheen',typeSheen[pokemon.types[0]]||'#8ed9ef50');
      target.disabled=true;target.setAttribute('aria-expanded','true');stage.setAttribute('aria-busy','true');
      reveal.hidden=false;reveal.inert=true;reveal.setAttribute('aria-hidden','true');stage.classList.add('pv-opening');
      finishRip=()=>{
        if(!opened||phase==='revealed')return;
        stopMotion();paintTear(1);paintOpen(1,1);setPhase('revealed');
        stage.classList.remove('pv-opening');stage.classList.add('pv-ripped');stage.setAttribute('aria-busy','false');
        reveal.inert=false;reveal.removeAttribute('aria-hidden');replay.hidden=false;
        status.textContent=pokemon.name+'. '+config.text.opened;reveal.focus({preventScroll:true});finishRip=null;
      };
      if(reduced.matches){finishRip();return;}
      const tearDuration=Math.max(80,300*(1-from)),duration=tearDuration+1180;
      animate(duration,value=>{
        const elapsed=value*duration;
        paintTear(from+(1-from)*ease(clamp(elapsed/tearDuration)));
        const opening=ease(clamp((elapsed-tearDuration)/780));
        const card=ease(clamp((elapsed-tearDuration-100)/1080));
        if(card>0&&phase==='opening')setPhase('revealing');
        paintOpen(opening,card);
      },()=>{if(finishRip)finishRip();});
    }
    function reset(){
      stopMotion();releasePointer();finishRip=null;nextPacky();opened=false;suppressClick=false;suppressClickUntil=0;setPhase('sealed');paintTear(0);paintOpen(0,0);setDirection(1);
      stage.classList.remove('pv-ripped','pv-opening');stage.setAttribute('aria-busy','false');
      target.disabled=false;target.setAttribute('aria-expanded','false');reveal.inert=true;reveal.hidden=true;reveal.removeAttribute('aria-hidden');reveal.scrollTop=0;
      replay.hidden=true;prepare();status.textContent=config.text.closed;target.focus({preventScroll:true});
    }
    function beginGesture(id,x,y,kind){
      if(opened||pointer)return;
      stopMotion();suppressClick=false;paintTear(0);setPhase('sealed');
      const width=target.getBoundingClientRect().width||224;
      pointer={id,x,y,kind,moved:false,direction:0,distance:0,threshold:Math.max(56,Math.min(92,width*.32))};
      stage.dataset.input=kind;
    }
    function moveGesture(id,x,y){
      if(!pointer||pointer.id!==id||opened)return false;
      const dx=x-pointer.x,dy=y-pointer.y,distance=Math.hypot(dx,dy);
      if(distance<7&&!pointer.moved)return false;
      if(!pointer.moved){pointer.direction=dx<-4?-1:1;pointer.moved=true;setDirection(pointer.direction);setPhase('dragging');}
      pointer.distance=distance;
      paintTear(distance/pointer.threshold);
      return true;
    }
    function endGesture(id,x,y,cancelled){
      if(!pointer||pointer.id!==id)return;
      if(!cancelled)moveGesture(id,x,y);
      const dragged=pointer.moved,complete=tear>=.85;
      releasePointer();
      if(dragged||cancelled){suppressClick=true;suppressClickUntil=Date.now()+600;}
      if(!cancelled&&dragged&&complete)rip();else snapBack();
    }
    target.addEventListener('pointerdown',e=>{
      if(e.pointerType==='touch'||e.isPrimary===false||(e.pointerType==='mouse'&&e.button!==0))return;
      beginGesture(e.pointerId,e.clientX,e.clientY,'pointer');
      if(pointer){try{if(target.setPointerCapture)target.setPointerCapture(e.pointerId);}catch{}}
    });
    const pointerMove=e=>{if(pointer&&pointer.kind==='pointer')moveGesture(e.pointerId,e.clientX,e.clientY);};
    const pointerUp=e=>{if(pointer&&pointer.kind==='pointer')endGesture(e.pointerId,e.clientX,e.clientY,false);};
    const pointerCancel=e=>{if(pointer&&pointer.kind==='pointer')endGesture(e.pointerId,e.clientX,e.clientY,true);};
    window.addEventListener('pointermove',pointerMove,{passive:true});window.addEventListener('pointerup',pointerUp);window.addEventListener('pointercancel',pointerCancel);
    target.addEventListener('lostpointercapture',pointerCancel);
    const trackedTouch=list=>Array.from(list).find(t=>pointer&&t.identifier===pointer.id);
    target.addEventListener('touchstart',e=>{
      if(e.touches.length!==1){if(pointer)snapBack();return;}
      const t=e.changedTouches[0];beginGesture(t.identifier,t.clientX,t.clientY,'touch');
    },{passive:true});
    target.addEventListener('touchmove',e=>{
      if(!pointer||pointer.kind!=='touch')return;
      if(e.touches.length!==1){suppressClick=true;suppressClickUntil=Date.now()+600;snapBack();return;}
      const t=trackedTouch(e.touches);if(t&&moveGesture(t.identifier,t.clientX,t.clientY)&&e.cancelable)e.preventDefault();
    },{passive:false});
    target.addEventListener('touchend',e=>{
      if(!pointer||pointer.kind!=='touch')return;
      const t=trackedTouch(e.changedTouches);if(!t)return;
      const moved=pointer.moved||Math.hypot(t.clientX-pointer.x,t.clientY-pointer.y)>=7;
      if(moved&&e.cancelable)e.preventDefault();endGesture(t.identifier,t.clientX,t.clientY,false);
    },{passive:false});
    target.addEventListener('touchcancel',e=>{const t=trackedTouch(e.changedTouches);if(t)endGesture(t.identifier,t.clientX,t.clientY,true);});
    target.addEventListener('click',e=>{if(e.detail!==0&&(suppressClick||Date.now()<suppressClickUntil)){e.preventDefault();suppressClick=false;return;}suppressClick=false;rip();});
    replay.addEventListener('click',reset);
    root.querySelectorAll('[data-rip]').forEach(b=>b.addEventListener('click',rip));
    const onMotionChange=()=>{if(reduced.matches){if(finishRip)finishRip();else if(pointer||phase==='resealing')snapBack();}};
    const onRipVisibility=()=>{if(document.hidden){if(finishRip)finishRip();else if(pointer||phase==='resealing')snapBack();}};const onRipBlur=()=>{if(pointer)snapBack();};window.addEventListener('blur',onRipBlur);
    reduced.addEventListener('change',onMotionChange);document.addEventListener('visibilitychange',onRipVisibility);
    setPhase('sealed');paintOpen(0,0);
    root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));root.querySelectorAll('[data-kind]').forEach(x=>{x.hidden=b.dataset.filter!=='all'&&x.dataset.kind!==b.dataset.filter})}));
    root.querySelectorAll('[data-visit]').forEach(b=>b.addEventListener('click',()=>root.querySelector('#pv-visit-info').scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'})));

    const showcaseCleanups=[];
    root.querySelectorAll('[data-showcase]').forEach((card,cardIndex)=>{
      const live=card.querySelector('[data-showcase-live]'),liveItems=live?JSON.parse(live.textContent):[];
      const items=liveItems.length?liveItems:JSON.parse(card.querySelector('[data-showcase-items]').textContent),image=card.querySelector('[data-showcase-image]'),pause=card.querySelector('[data-showcase-pause]');
      if(liveItems.length){image.src=items[0].url;image.alt=items[0].name;card.querySelector('[data-showcase-name]').textContent=items[0].name;card.querySelector('[data-showcase-detail]').textContent=items[0].detail;card.querySelector('.pv-showcase-art').href=items[0].href;card.querySelector('[data-showcase-count]').textContent='1 / '+items.length;}
      if(items.length<2)return;
      let index=0,paused=reduced.matches,hovered=false,focused=false,visible=false,timer=null,request=0;
      card.querySelector('.pv-showcase-controls').hidden=false;
      const stop=()=>{clearTimeout(timer);timer=null;};
      const syncButton=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);};
      const schedule=()=>{stop();if(!paused&&!motionPaused&&!hovered&&!focused&&visible&&!document.hidden&&!card.hidden)timer=setTimeout(()=>show(index+1),5200+cardIndex*650);};
      function show(next){const selected=(next+items.length)%items.length,entry=items[selected],token=++request;stop();const preload=new Image();preload.onload=()=>{if(token!==request||!card.isConnected)return;index=selected;image.src=entry.url;image.alt=entry.name;if(entry.href)card.querySelector('.pv-showcase-art').href=entry.href;image.classList.remove('pv-photo-enter');void image.offsetWidth;if(!reduced.matches)image.classList.add('pv-photo-enter');card.querySelector('[data-showcase-name]').textContent=entry.name;card.querySelector('[data-showcase-detail]').textContent=entry.detail;card.querySelector('[data-showcase-count]').textContent=(index+1)+' / '+items.length;schedule();};preload.onerror=()=>{if(token===request)schedule();};preload.src=entry.url;}
      card.querySelector('[data-showcase-prev]').addEventListener('click',()=>show(index-1));
      card.querySelector('[data-showcase-next]').addEventListener('click',()=>show(index+1));
      pause.addEventListener('click',()=>{paused=!paused;syncButton();schedule();});
      card.addEventListener('mouseenter',()=>{hovered=true;stop();});card.addEventListener('mouseleave',()=>{hovered=false;schedule();});
      card.addEventListener('focusin',()=>{focused=true;stop();});card.addEventListener('focusout',e=>{if(!card.contains(e.relatedTarget)){focused=false;schedule();}});
      const visibility=()=>schedule(),motion=()=>{paused=reduced.matches;syncButton();schedule();};
      document.addEventListener('visibilitychange',visibility);reduced.addEventListener('change',motion);root.addEventListener('bigpack:motion',schedule);
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.15});observer.observe(card);
      const hiddenObserver=new MutationObserver(schedule);hiddenObserver.observe(card,{attributes:true,attributeFilter:['hidden']});
      syncButton();showcaseCleanups.push(()=>{stop();request++;observer.disconnect();hiddenObserver.disconnect();document.removeEventListener('visibilitychange',visibility);reduced.removeEventListener('change',motion);root.removeEventListener('bigpack:motion',schedule);});
    });
    const sections=[...root.querySelectorAll('.pv-hero,.pv-section,.pv-feature,.pv-events,.pv-location')];
    const layers=sections.map(s=>{s.classList.add('pv-scene');const layer=document.createElement('div');layer.className='pv-background';layer.setAttribute('aria-hidden','true');const img=document.createElement('img');img.alt='';img.width=475;img.height=475;img.decoding='async';img.loading=s.classList.contains('pv-hero')?'eager':'lazy';layer.append(img);s.append(layer);return img});
    let current=-1,routeIndex=Math.floor(Math.random()*config.routes.length)-1;
    function choose(){let last=current;try{if(last<0)last=Number(sessionStorage.getItem('big-pack-encounter')??-1)}catch{}const options=config.themes.map((_,i)=>i).filter(i=>i!==last);current=options[Math.floor(Math.random()*options.length)];try{sessionStorage.setItem('big-pack-encounter',String(current))}catch{}const t=config.themes[current];layers.forEach((img,i)=>{const n=i===0?t.members.length-1:Math.min(t.members.length-1,Math.floor(i*t.members.length/sections.length));img.src=t.members[n].url;sections[i].style.setProperty('--scene-wash',['#e8f5e8','#fff1df','#e6f2fa'][current%3]);sections[i].dataset.encounter=t.members[n].name});root.querySelector('.pv-themed-path').textContent=t.members.map(x=>x.name).join(' → ');root.dataset.encounter=t.members[t.members.length-1].name;routeIndex=(routeIndex+1)%config.routes.length;root.dataset.route=config.routes[routeIndex].id;root.querySelector('[data-route-label]').textContent=config.routes[routeIndex].label;root.dispatchEvent(new CustomEvent('bigpack:encounter',{detail:{name:t.name,route:config.routes[routeIndex].id}}))}
    root.querySelector('[data-encounter]').addEventListener('click',choose);choose();
    const sceneObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{entry.target.dataset.sceneVisible=String(entry.isIntersecting);}),{threshold:0});sections.forEach(scene=>sceneObserver.observe(scene));
    const unload=e=>{if(!e.target.contains(root))return;stopMotion();releasePointer();window.removeEventListener('pointermove',pointerMove);window.removeEventListener('pointerup',pointerUp);window.removeEventListener('pointercancel',pointerCancel);clearInterval(packyTimer);stageObserver.disconnect();reduced.removeEventListener('change',onMotionChange);document.removeEventListener('visibilitychange',onRipVisibility);window.removeEventListener('blur',onRipBlur);showcaseCleanups.forEach(cleanup=>cleanup());sceneObserver.disconnect();reduced.removeEventListener('change',onAmbientMotionChange);document.removeEventListener('shopify:section:unload',unload)};document.addEventListener('shopify:section:unload',unload);
  };
  document.querySelectorAll('[data-pack-vault]').forEach(initialize);
  document.addEventListener('shopify:section:load',e=>initialize(e.target.querySelector('[data-pack-vault]')));
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
